import Linkify from 'react-linkify';

const Link = ({ str }) => {
  if (typeof str !== 'string') return str;

  return (
    <Linkify
      componentDecorator={(decoratedHref, decoratedText, key) => (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={decoratedHref}
          key={key}>
          {decoratedText}
        </a>
      )}>
      {str}
    </Linkify>
  );
};

export default Link;
